jQuery(document).ready(function ($) {
    const $blocks = $('.wp-block-jormi-blocks-subnavigation');
    if ($blocks.length < 0) return;

    $blocks.each(function() {
        const $block = $(this);
        const navItems = $block.find('[data-anchor]').toArray();
        const sections = navItems.map(item => $($(item).attr('data-anchor'))[0]);
                
        // Retrieve colors from data attributes
        const activeColor = $block.data('active-color');
        const defaultColor = $block.data('default-color');
        
        // Create placeholder to prevent layout shift
        let blockPlaceholder = null;
        $block.before(blockPlaceholder);
        
        let lastScroll = 0;
        let ticking = false;
        const blockOffset = $block.offset().top;
        
        const getOffsets = () => {
            const blockHeight = $block.outerHeight();
            // Consider other headers
            const headerHeight = $('.site-header').height() || parseFloat($(':root').css('--header-height')) || 0;
            const adminBar = $('#wpadminbar');
            const adminBarHeight = adminBar.length ? adminBar.outerHeight() : 0;
            return { blockHeight, headerHeight, adminBarHeight };
        };
        
        const handleNavigation = () => {
            const currentScroll = $(window).scrollTop();
            const viewportHeight = $(window).height();
            const { blockHeight, headerHeight, adminBarHeight } = getOffsets();
            const totalOffset = headerHeight + adminBarHeight + blockHeight;
            
            // Handle positioning logic
            // Handle block positioning
            if (currentScroll >= blockOffset) {
                $block.css({
                    position: 'fixed',
                    left: '0',
                    right: '0',
                    zIndex: '50',
                    transition: 'all 0.3s ease',
                    bottom: '0'
                });
                $block.addClass('shadow-inner');
                if (blockPlaceholder) {
                    blockPlaceholder.css('height', `${blockHeight}px`);
                }
            } else {
                $block.css({ position: 'static' });
                $block.removeClass('shadow-inner');
                if (blockPlaceholder) {
                    blockPlaceholder.css('height', '0px');
                }
            }

            // Handle specific style
            if ($block.hasClass('subnavigation-vertical') && window.matchMedia('(max-width: 991px)').matches) {
                $block.find('> div').addClass('container');
            }
            
            // Check active section (applies to all blocks)
            const activeIndex = sections.findIndex(section => {
                if (!section) return false;
                const $section = $(section);
                const sectionHeight = $section.outerHeight();
                const sectionTop = $section.offset().top - totalOffset;
                const sectionBottom = sectionTop + sectionHeight;
                const section10PercentTop = sectionTop + (sectionHeight * 0.10);
                const section90PercentBottom = sectionBottom - (sectionHeight * 0.10);
                return currentScroll + viewportHeight > section10PercentTop && currentScroll < section90PercentBottom;
            });
            
            // Update nav item styles
            navItems.forEach((item, index) => {
                $(item).css({
                    color: index === activeIndex ? activeColor : defaultColor
                });
            });
            
            lastScroll = currentScroll;
            ticking = false;
        };
        
        // Create scroll handler for this block instance
        const scrollHandler = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    handleNavigation();
                });
                ticking = true;
            }
        };        
        $(window).on('scroll', scrollHandler);
        
        // Initial call
        handleNavigation();
    });
});